export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/laptop.c0f74d1c-55bb52.png";